module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_20.a70a80d6.png";